import type {MobileAlgoContext, PluginContext, PluginContextHelper} from '../types'

export const createPluginContext = (contextHelper: PluginContextHelper, context: MobileAlgoContext): PluginContext => {
    return {
        get: (key: string): any => contextHelper.ctxGet(context, key),
        set: (key: any, value: string): void => contextHelper.ctxSet(context, key, value)
    }
}
